import { stringify } from "querystring";

const strf = obj => {
  const p = {};
  const keys = Object.keys(obj);
  for (let key of keys) {
    if (obj[key] !== undefined) {
      p[key] = obj[key];
    }
  }
  return stringify(p);
};

const doFetch = (method, url, qs, body) => {
  url = process.env.REACT_APP_API_URL + url;
  if (qs) {
    url += "?" + strf(qs);
  }
  return fetch(url, {
    method: method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: body ? strf(body) : undefined
  }).then(res => {
    if (res.ok) {
      if (res.status !== 204) {
        return res.json();
      }
    } else {
      return res.json().then(json => {
        throw new Error(json.error);
      });
    }
  });
};

export const get = (url, params) => doFetch("GET", url, params);
export const post = (url, params) => doFetch("POST", url, null, params);
export const put = (url, params) => doFetch("PUT", url, null, params);
export const del = (url, params) => doFetch("DELETE", url, null, params);



// WEBPACK FOOTER //
// ./src/api.js